const { getPoleOfInaccessibility } = require('../mapUtils');

const createTextMarker = async function(layer, locationRecord, usePoleOfInaccessibility = true) {
  // Get the center of the layer; use bounding-box center for thermostats
  let layerCenter;
  if (locationRecord.name === 'T') {
    // For thermostat markers, use the map bounds center
    layerCenter = layer.getBounds().getCenter();
  } else {
    // Use pole of inaccessibility for other shapes
    if (usePoleOfInaccessibility) {
      layerCenter = await getPoleOfInaccessibility(layer, 0.00001);
    }
    if (Array.isArray(layerCenter)) {
      layerCenter = { lat: layerCenter[1], lng: layerCenter[0] };
    }
    if (!layerCenter) {
      layerCenter = layer.getBounds().getCenter();
    }
  }

  // Create the SVG element for the text overlay
  const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  
  // Set a fixed viewBox size, which will keep the text size consistent
  svgElement.setAttribute('viewBox', '0 0 400 100'); // Increased height for two lines of text

  if (locationRecord.roomNumber) {
    svgElement.innerHTML = `
      <rect width="400" height="100" fill="#ffffff" opacity="0.0"/>
      <text x="200" y="30" style="font-size:18px; text-anchor: middle; fill: #000000">
        ${locationRecord.roomNumber}
      </text>
      <text x="200" y="70" style="font-size:14px; text-anchor: middle; fill: #000000">
        ${locationRecord.name}
      </text>
    `;
  } else {
    // Center single-line text vertically for thermostats or other single-label records
    svgElement.innerHTML = `
      <rect width="400" height="100" fill="#ffffff" opacity="0.0"/>
      <text x="200" y="52" style="font-size:18px; text-anchor: middle; dominant-baseline: middle; fill: #000000">
        ${locationRecord.name}
      </text>
    `;
  }

  // Define a small, fixed-sized bounding box for the SVG overlay (to keep the size consistent)
  const svgElementBounds = [
    [layerCenter.lat + 0.00001, layerCenter.lng + 0.00004], // Top-right corner
    [layerCenter.lat - 0.00001, layerCenter.lng - 0.00004]  // Bottom-left corner
  ];
  // Create the SVG overlay with fixed bounds
  const svgOverlay = L.svgOverlay(svgElement, svgElementBounds, { interactive: false, bubblingMouseEvents: true});

  return svgOverlay;
};

module.exports = createTextMarker;
